const THEMES = [
  'purple',
  'blue',
  'turquoise',
  'yellow',
  'pink',
];

export default THEMES;
